module.exports = __webpack_public_path__ + "img/cheque-active.c9864361.svg";